import Banner from '@/components/Banner';
import Footer from '@/components/Footer';
import Partner from '@/components/Partner';
import TabNav from '@/components/TabNav';
import SceneIntroduction from '@/components/SceneIntroduction';
import InterfaceExperience from '@/components/InterfaceExperience';
import DataEffect from '@/components/DataEffect';
import BaseList from '@/components/BaseList';
import OverallEffect from '@/components/DataEffect/OverallEffect';
import TrafficBucket from '@/components/DataEffect/TrafficBucket';
import TabAnchor from '@/components/TabAnchor';
// export { default as homeConfig } from './home.config';
export { default as getHomeConfig } from './homes.config';
// export { default as detailConfig } from './detail.config';
export { default as detailConfig } from './details.config';
export const componentMap = {
    Banner,
    Footer,
    Partner,
    TabNav,
    SceneIntroduction,
    InterfaceExperience,
    DataEffect,
    BaseList,
    OverallEffect,
    TrafficBucket,
    TabAnchor,
};
